import api from "../config/api";

export const getAllTransactions = async (userId) => {
  if (!userId) {
    throw new Error("[GET_ALL_TRANSACTIONS] User ID missing.");
  }

  const { data } = await api.get(`/platform/transactions/${userId}`);
  return data;
};

export const payInvoice = async (payload) => {
  const { data } = await api.post(`/platform/transactions/payments`, payload);

  return data;
};

export const refundInvoice = async (payload) => {
  const { data } = await api.post(
    `/platform/transactions/payments/refund`,
    payload
  );

  return data;
};
